import type { ReactNode } from 'react'
import s from './List.module.css'

/** Steps in order (`ordered`) or a few points. For a sentence or two each; a table is better for data. */
export function List(props: { items: ReactNode[]; ordered?: boolean }) {
  const Tag = props.ordered ? 'ol' : 'ul'
  return (
    <Tag className={props.ordered ? s.ordered : s.list}>
      {props.items.map((item, i) => (
        <li key={i}>{item}</li>
      ))}
    </Tag>
  )
}
